import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Student } from 'src/app/modules/students/models/student.model';

@Component({
    selector: 'app-student-selector',
    templateUrl: './student-selector.component.html',
    styleUrls: ['./student-selector.component.scss']
})
export class StudentSelectorComponent implements OnInit {

    @Input() students        : Student[];
    @Input() selected?       : Student;
    @Input() defaultSelected?: boolean = false;
    @Input() placeholder?    : string = 'Seleccione un participante...';
    @Input() showClear?      : boolean = false;
    @Input() showFilter?     : boolean = false;

    @Output() selectedChange = new EventEmitter<Student>();

    constructor() { }

    ngOnInit(): void {

        this.selected = this.defaultSelected ? this.students[0] : this.selected;
        this.onSelectionChange();

    }

    public onSelectionChange() {

        this.selectedChange.emit(this.selected);

    }

}
